import { Typography as e } from "../../../Typography/Typography.mjs";
import { IconButton as t } from "../../Button/IconButton.mjs";
import { CalGrid as n, CalMonth as r, CalNav as i, Day as a, DayAnnotationLabel as ee, DayLabel as o, DayTooltip as s, FluidCalGrid as c, MonthCell as l, MonthGrid as u, NavArrowWrap as d, PickerPanel as f, TitleButton as p, YearNav as m } from "../styled/CalendarMonth.styled.mjs";
import { Skeleton as te } from "../../Primitives/Skeleton.mjs";
import { useEffect as h, useState as g } from "react";
import { useLocale as _, useTranslation as v } from "@maat/store-i18n";
import { Fragment as ne, jsx as y, jsxs as b } from "react/jsx-runtime";
import { ChevronLeft as x, ChevronRight as S } from "lucide-react";
import { addDaysToDateString as C, dayOfDate as w, getCalendarDays as T, getMonthNames as E, getWeekdayNames as D, isInRange as re, isSameDay as O, isToday as ie } from "@maat/datetime";
//#region src/components/DatePicker/components/CalendarMonth.tsx
var ae = (e, t) => {
	let n = 1, r = t;
	for (; r < e;) r = C(r, 1), n++;
	return n;
}, k = ({ year: C, month: k, onPrev: oe, onNext: se, selectedDate: A, selectedDates: j, rangeStart: M, rangeEnd: N, hoverDate: P, onDayClick: F, onDayHover: I, minDate: L, maxDate: R, hidePrev: z, hideNext: B, onSetView: V, fluid: H, annotations: U, blockedRanges: W, disabledDates: G, reasonForDate: ce, loading: K }) => {
	let { t: q } = v("ds"), { locale: J } = _(), Y = E(J), le = E(J, "short"), ue = D(J, "short", 1), de = T(C, k), fe = N ?? P ?? null, X = H ? c : n, [pe, Z] = g(!1), [Q, $] = g(C);
	h(() => {
		$(C);
	}, [C]);
	let me = () => /* @__PURE__ */ b(ne, { children: [ue.map((t) => /* @__PURE__ */ y(o, { children: /* @__PURE__ */ y(e, {
		variant: "caption",
		weight: "medium",
		color: "secondary",
		inline: !0,
		children: t
	}) }, t)), de.map(({ date: e, current: t }, n) => {
		if (!e) return /* @__PURE__ */ y("span", { "aria-hidden": "true" }, n);
		let r = W?.some((t) => e >= t.from && e <= t.to) ?? !1, i = r && !!R && e === R, o = r && !i || (L ? e < L : !1) || (R ? e > R : !1) || (G?.includes(e) ?? !1), c = (A ? O(e, A) : !1) || (j?.some((t) => O(t, e)) ?? !1), l = M ? O(e, M) : !1, u = N ? O(e, N) : !1, d = re(e, M ?? null, fe), f = U?.find((t) => O(t.date, e)), p = !!f || r || K && !o, m = r ? "—" : f?.label, h = r ? "muted" : f?.variant ?? "default", g;
		return l && u || (l ? g = q("ds:datePicker.checkInDay") : u ? g = q("ds:datePicker.checkOutDay") : d && M ? g = q("ds:datePicker.nightNumber", { count: ae(e, M) }) : i ? g = q("ds:datePicker.availableCheckout") : o && (g = ce?.(e))), /* @__PURE__ */ b(a, {
			type: "button",
			$today: ie(e),
			$sel: c,
			$start: l,
			$end: u,
			$inRange: d,
			$outside: !t,
			$off: o,
			$hasAnnotation: p,
			$blocked: r,
			onClick: () => !o && F(e),
			onMouseEnter: () => I?.(e),
			onMouseLeave: () => I?.(null),
			"aria-label": g ?? e,
			tabIndex: o ? -1 : 0,
			children: [
				g && /* @__PURE__ */ y(s, { children: g }),
				/* @__PURE__ */ y("span", { children: w(e) }),
				m ? /* @__PURE__ */ y(ee, {
					$variant: h,
					children: m
				}) : K && !r && !o ? /* @__PURE__ */ y(te, {
					width: 24,
					height: 8,
					radius: "sm"
				}) : null
			]
		}, n);
	})] });
	return /* @__PURE__ */ b(r, {
		$fluid: H,
		children: [/* @__PURE__ */ b(i, { children: [
			/* @__PURE__ */ y(d, {
				$hidden: z,
				children: /* @__PURE__ */ y(t, {
					icon: /* @__PURE__ */ y(x, { size: 15 }),
					label: q("ds:datePicker.prevMonth"),
					variant: "ghost",
					size: "sm",
					onClick: oe
				})
			}),
			V ? /* @__PURE__ */ y(p, {
				type: "button",
				onClick: () => Z((e) => !e),
				"aria-label": q("ds:datePicker.pickMonthYear"),
				children: /* @__PURE__ */ b(e, {
					variant: "label",
					weight: "semibold",
					inline: !0,
					children: [
						Y[k],
						" ",
						C
					]
				})
			}) : /* @__PURE__ */ b(e, {
				variant: "label",
				weight: "semibold",
				inline: !0,
				children: [
					Y[k],
					" ",
					C
				]
			}),
			/* @__PURE__ */ y(d, {
				$hidden: B,
				children: /* @__PURE__ */ y(t, {
					icon: /* @__PURE__ */ y(S, { size: 15 }),
					label: q("ds:datePicker.nextMonth"),
					variant: "ghost",
					size: "sm",
					onClick: se
				})
			})
		] }), V && pe ? /* @__PURE__ */ b(f, { children: [/* @__PURE__ */ b(m, { children: [
			/* @__PURE__ */ y(t, {
				icon: /* @__PURE__ */ y(x, { size: 15 }),
				label: q("ds:datePicker.prevYear"),
				variant: "ghost",
				size: "sm",
				onClick: () => $((e) => e - 1)
			}),
			/* @__PURE__ */ y(e, {
				variant: "label",
				weight: "semibold",
				inline: !0,
				children: Q
			}),
			/* @__PURE__ */ y(t, {
				icon: /* @__PURE__ */ y(S, { size: 15 }),
				label: q("ds:datePicker.nextYear"),
				variant: "ghost",
				size: "sm",
				onClick: () => $((e) => e + 1)
			})
		] }), /* @__PURE__ */ y(u, { children: le.map((e, t) => /* @__PURE__ */ y(l, {
			type: "button",
			$sel: t === k && Q === C,
			onClick: () => {
				V({
					year: Q,
					month: t
				}), Z(!1);
			},
			children: e
		}, t)) })] }) : /* @__PURE__ */ y(X, { children: me() })]
	});
};
//#endregion
export { k as CalendarMonth };
